module.exports = __webpack_public_path__ + "img/WorldBuildingABCEntranceOpen.b7ff8fff.png";